import { Link, useLocation, Outlet } from 'react-router-dom';
import { LayoutDashboard, ShoppingBag, Plus, Package, ArrowLeft, Sparkles } from 'lucide-react';

const AdminLayout = () => {
  const location = useLocation();

  const navItems = [
    { name: 'Panel', path: '/admin', icon: LayoutDashboard, exact: true },
    { name: 'Çantalar', path: '/admin/bags', icon: ShoppingBag },
    { name: 'Yeni çanta', path: '/admin/add-bag', icon: Plus },
    { name: 'Məhsullar', path: '/admin/products', icon: Package },
    { name: 'Yeni məhsul', path: '/admin/add-product', icon: Plus },
  ];

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen flex bg-brand-cream" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-72 bg-white border-r border-brand-secondary/30 flex flex-col fixed h-full shadow-lg" data-testid="admin-sidebar">
        {/* Logo */}
        <div className="p-6 border-b border-brand-secondary/30">
          <Link to="/admin" className="font-serif text-2xl text-brand-brown">
            Turkan <span className="text-brand-primary italic">Rustamova</span>
          </Link>
          <div className="flex items-center gap-2 mt-2">
            <Sparkles className="w-4 h-4 text-brand-gold" />
            <p className="text-xs text-brand-muted font-medium">İdarə Paneli</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-6 px-4">
          <p className="text-xs text-brand-muted uppercase tracking-wider mb-4 px-3">Menyu</p>
          <ul className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path, item.exact);
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 ${
                      active
                        ? 'bg-gradient-to-r from-brand-primary to-[#E08E73] text-white shadow-warm'
                        : 'text-brand-brown hover:bg-brand-accent/30'
                    }`}
                    data-testid={`admin-nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <Icon className="w-5 h-5" />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-brand-secondary/30">
          <Link
            to="/"
            className="flex items-center gap-3 px-4 py-3 text-brand-muted hover:text-brand-primary rounded-xl hover:bg-brand-accent/20 transition-all duration-300"
            data-testid="admin-back-to-site"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Sayta qayıt</span>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-72">
        {/* Header */}
        <header className="bg-white/80 backdrop-blur-md border-b border-brand-secondary/30 px-8 py-5 sticky top-0 z-10" data-testid="admin-header">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-serif text-brand-brown">
              {navItems.find((item) => isActive(item.path, item.exact))?.name || 'Admin'}
            </h1>
            <div className="flex items-center gap-4">
              <span className="text-sm text-brand-muted bg-brand-accent/30 px-4 py-2 rounded-full">
                {new Date().toLocaleDateString('az-AZ', {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })}
              </span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
